import React from 'react';
import Recoil from 'recoil';
import * as AppStore from 'stores/AppStore';

export default function useCategorizedPages(category) {
  const pages = Recoil.useRecoilValue(AppStore.navigation.pages(category));
  return pages;
}
